const initialstate = {
  categories: [],
  subCategories: [],
  subCategory: {
    name: '',
    CategoryId: 0
  }
}

export default function categoryReducer(state = initialstate, action) {
  switch (action.type) {
    case 'categories/fetchSuccess':
      return {
        ...state,
        categories: action.payload
      }
    case 'subCategories/fetchSuccess':
      return {
        ...state,
        subCategories: action.payload
      }
    case 'subCategory/fetchSuccess':
      return {
        ...state,
        subCategory: action.payload
      }
    default:
      return state
  }
}

